import { Routes, Route } from "react-router-dom"

import Style from "./style"
import { PublicRoute, PrivateRoute, InitPageQueryRouter } from "./lib/conditionalRouter"

import Login from "./ui/Login"
import FindId from "./ui/FindId"
import FindpW from "./ui/FindPw"
import Signup from "./ui/Signup"
import SignupSns from "./ui/SignupSns"

import Home from "./ui/Home"
import AdDetail from "./ui/AdDetail"
import NoticeDetail from "./ui/NoticeDetail"
import YoutubeList from "./ui/YoutubeList"
import MediaList from "./ui/MediaList"

import EventList from "./ui/EventList"
import EventDetail from "./ui/EventDetail"
import SeriesDetail from "./ui/SeriesDetail"

import QR from "./ui/QR"
import Ranking from "./ui/Ranking"

import TryoutExamList from "./ui/TryoutExamList"
import TyroutExamTaking from "./ui/TyroutExamTaking"
import TryoutExamResult from "./ui/TryoutExamResult"

import TryoutRealExamList from "./ui/TryoutRealExamList"
import TryoutRealExamPayment from "./ui/TryoutRealExamPayment"

import Mypage from "./ui/Mypage"
import MyTicketList from "./ui/MyTicketList"
import MySeedTicketRecord from "./ui/MySeedTicketRecord"
import MyStoreTicketRecord from "./ui/MyStoreTicketRecord"
import MyEventRecord from "./ui/MyEventRecord"
import MyTryoutRecord from "./ui/MyTryoutRecord"

import TryoutExamPayment from "./ui/TryoutExamPayment"
import TryoutEventPayment from "./ui/TryoutEventPayment"
import PremiumPayment from "./ui/PremiumPayment"
import PaymentDone from "./ui/PaymentDone"
import PaymentFail from "./ui/PaymentFail"

import Term from "./ui/Term"
import NotFound from "./ui/NotFound"
import InternalServerError from "./ui/InternalServerError"

const Router = () => {

    return (
        <Style.Main>
            <Routes>

                {/* 상관 없음 */}
                <Route index element={<Home />} />
                <Route element={<InitPageQueryRouter />} >
                    <Route path="/youtube" element={<YoutubeList />} />
                    <Route path="/media" element={<MediaList />} />
                    <Route path="/ranking" element={<Ranking />} />
                </Route>
                <Route path="/ad/:idx/detail" element={<AdDetail />} />
                <Route path="/notice/:idx/detail" element={<NoticeDetail />} />

                <Route path="/event">
                    <Route element={<InitPageQueryRouter />} >
                        <Route index element={<EventList />} />
                    </Route>
                    <Route path=":idx/detail" element={<EventDetail />} />
                    <Route path="series/:idx/detail" element={<SeriesDetail />} />
                </Route>

                {/* 비로그인 */}
                <Route element={<PublicRoute />}>
                    <Route path="/login" element={<Login />} />
                    <Route path="/find">
                        <Route path="id" element={<FindId />} />
                        <Route path="password" element={<FindpW />} />
                    </Route>
                    <Route path="/signup">
                        <Route index element={<Signup />} />
                        <Route path="sns" element={<SignupSns />} />
                    </Route>
                </Route>

                {/* 로그인 */}
                <Route element={<PrivateRoute />}>
                    <Route path="/qr" element={<QR />} />

                    <Route path="/tryout">
                        <Route index element={<TryoutExamList />} />
                        <Route path="payment/:idx/taking" element={<TyroutExamTaking />} />
                        <Route path="payment/:idx/result" element={<TryoutExamResult />} />
                    </Route>

                     {/* @Desc 트라이아웃 실기시험 Router*/}
                    <Route path="/tryout-real">
                        <Route index element={<TryoutRealExamList />} />
                        {/* <Route path="payment/:idx/taking" element={<TyroutExamTaking />} /> */}
                        {/* <Route path="payment/:idx/result" element={<TryoutExamResult />} /> */}
                    </Route>

                    <Route path="/payment">
                        <Route path="exam" element={<TryoutExamPayment />} />
                        <Route path="real" element={<TryoutRealExamPayment />} />
                        <Route path="event" element={<TryoutEventPayment />} />
                        <Route path="premium" element={<PremiumPayment />} />
                        <Route path="fail" element={<PaymentFail />} />
                        <Route path=":type/done" element={<PaymentDone />} />
                    </Route>

                   

                    {/* @Desc 트라이아웃 실기시험 결제 Router */}
                    {/* <Route path="/payment-real"> */}
                        {/* <Route path="exam" element={<TryoutRealExamPayment />} /> */}
                        {/* <Route path="event" element={<TryoutEventPayment />} /> */}
                        {/* <Route path="premium" element={<PremiumPayment />} /> */}
                        {/* <Route path="fail" element={<PaymentFail />} /> */}
                        {/* <Route path=":type/done" element={<PaymentDone />} /> */}
                    {/* </Route> */}

                    <Route path="/my">
                        <Route index element={<Mypage />} />
                        <Route element={<InitPageQueryRouter />} >
                            <Route path="ticket/store/record" element={<MyStoreTicketRecord />} />
                            <Route path="ticket/seed/record" element={<MySeedTicketRecord />} />
                            <Route path="event/record" element={<MyEventRecord />} />
                        </Route>
                        <Route path="ticket" element={<MyTicketList />} />
                        <Route path="tryout/record" element={<MyTryoutRecord />} />
                    </Route>
                </Route>

                {/* 상관 없음 */}
                <Route path="/term/:type" element={<Term />} />
                <Route path="/500" element={<InternalServerError />} />
                <Route path="*" element={<NotFound />} />

            </Routes>
        </Style.Main>
    )
}

export default Router